import React, {useEffect} from "react";
import {Button, Card, Col, Form, Row} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {createSelector} from "reselect";
import {getCategoryList as onGetCategoryList} from "../../../slices/category/thunk";
import {getBrandList as onGetBrandList} from "../../../slices/brand/thunk";
import {getColorsList as onGetColorsList} from "../../../slices/color/thunk";

const SearchData = ({setSearchData}: any) => {

    const dispatch = useDispatch<any>();
    const selectFiltersData = createSelector(
        (state: any) => state,
        (state) => ({
            brandList: state.Brand.brandList,
            categoryList: state.Category.categoryList,
            colorsList: state.Colors.colorsList
        })
    );
    const {brandList, categoryList, colorsList} = useSelector(selectFiltersData);
    useEffect(() => {
        dispatch(onGetCategoryList());
        dispatch(onGetBrandList());
        dispatch(onGetColorsList());
    }, [dispatch]);

    return (
        <React.Fragment>
            <Row>
                <Col lg={12}>
                    <Card>
                        <Card.Body>
                            <Row className="g-3">
                                <Col className="col-xxl">
                                    <div className="search-box">
                                        <Form.Control
                                            type="text"
                                            className="search"
                                            placeholder="Search products..."
                                            onChange={(e) =>
                                                setSearchData((prev: any) => ({
                                                    ...prev,
                                                    name: e.target.value
                                                }))
                                            }
                                        />
                                        <i className="ri-search-line search-icon"></i>
                                    </div>
                                </Col>
                                <Col sm={6} className="col-xxl">
                                    <div>
                                        <Form.Select
                                            className="form-control"
                                            onChange={(e) =>
                                                setSearchData((prev: any) => ({
                                                    ...prev,
                                                    categoryId: e.target.value || null
                                                }))
                                            }
                                        >
                                            <option value="">Category</option>

                                            {categoryList?.content?.map((category: any) => (
                                                <option value={category.id} key={category.id}>
                                                    {category.name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </div>
                                </Col>

                                <Col sm={6} className="col-xxl">
                                    <div>
                                        <Form.Select
                                            id="idCategory"
                                            className="form-control"
                                            onChange={(e) =>
                                                setSearchData((prev: any) => ({
                                                    ...prev,
                                                    brandId: e.target.value || null
                                                }))
                                            }
                                        >
                                            <option value="">Brand</option>

                                            {brandList?.content?.map((brand: any) => (
                                                <option value={brand.id} key={brand.id}>
                                                    {brand.name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </div>
                                </Col>
                                <Col sm={6} className="col-xxl">
                                    <div>
                                        <Form.Select
                                            id="idCategory"
                                            className="form-control"
                                            onChange={(e) =>
                                                setSearchData((prev: any) => ({
                                                    ...prev,
                                                    colorId: e.target.value || null
                                                }))
                                            }
                                        >
                                            <option value="">Color</option>

                                            {colorsList?.content?.map((color: any) => (
                                                <option value={color.id} key={color.id}>
                                                    {color.name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </div>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

        </React.Fragment>
    );
}

export default SearchData;